import { C } from "@hikari/vault-core";

export default function Header({ onNav, onEnter, view }) {
    const linkStyle = (active) => ({
        background: "transparent",
        border: "none",
        color: active ? C.text : C.muted,
        fontFamily: C.font,
        fontSize: "0.85rem",
        cursor: "pointer",
        padding: "0.4rem 0.6rem",
    });
    return (
        <header
            style={{
                position: "sticky",
                top: 0,
                zIndex: 20,
                background: "rgba(7,9,13,0.85)",
                backdropFilter: "blur(12px)",
                borderBottom: `1px solid ${C.border}`,
                padding: "0.9rem 1.25rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontFamily: C.font,
            }}
        >
            <button
                type="button"
                onClick={() => onNav("landing")}
                style={{
                    background: "transparent",
                    border: "none",
                    color: C.text,
                    fontFamily: C.font,
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    cursor: "pointer",
                    letterSpacing: "0.02em",
                }}
            >
                <span style={{ color: C.accent }}>◆</span>&nbsp; Hikari Vault
            </button>
            <nav style={{ display: "flex", gap: "0.25rem", alignItems: "center" }}>
                <button type="button" style={linkStyle(view === "security")} onClick={() => onNav("security")}>Security</button>
                <button type="button" style={linkStyle(view === "privacy")} onClick={() => onNav("privacy")}>Privacy</button>
                <button type="button" style={linkStyle(view === "terms")} onClick={() => onNav("terms")}>Terms</button>
                <button
                    type="button"
                    onClick={onEnter}
                    style={{
                        marginLeft: "0.5rem",
                        background: C.accent,
                        color: "#fff",
                        border: "none",
                        padding: "0.45rem 1rem",
                        fontFamily: C.font,
                        fontSize: "0.82rem",
                        cursor: "pointer",
                        borderRadius: "0.25rem",
                    }}
                >
                    Open vault
                </button>
            </nav>
        </header>
    );
}
